export const MODULOS_POR_ROL: { [key: string]: string[] } = {
    "esInvestigador" : ["","Proyectos","sessionNull"],
    "esDelegado" : ["","Solicitudes","sessionNull"],
    "esVicerrector": ["","Solicitudes","sessionNull"],
    "esAdministrador": ["","Reportes","sessionNull", "AyudAcad"]
};